import React, { useMemo } from "react";
import { motion } from "framer-motion";

const COLORS = ["var(--mn-gold)", "var(--mn-mint)", "var(--mn-terra)"];

export default function Particles({ count = 18, className = "" }) {
  const dots = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        id: i,
        left: (i * 53 + 13) % 100,
        top: (i * 37 + 7) % 100,
        size: 3 + ((i * 7) % 5),
        color: COLORS[i % COLORS.length],
        delay: (i % 6) * 0.7,
        duration: 6 + (i % 5) * 1.6,
        hex: i % 4 === 0,
      })),
    [count]
  );

  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {dots.map((d) => (
        <motion.span
          key={d.id}
          className="absolute rounded-full"
          style={{
            left: `${d.left}%`,
            top: `${d.top}%`,
            width: d.size,
            height: d.size,
            background: d.color,
            opacity: 0.35,
            clipPath: d.hex ? "polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%)" : undefined,
            borderRadius: d.hex ? 0 : "50%",
          }}
          animate={{ y: [0, -26, 0], opacity: [0.15, 0.55, 0.15] }}
          transition={{ duration: d.duration, delay: d.delay, repeat: Infinity, ease: "easeInOut" }}
        />
      ))}
    </div>
  );
}

export function GradientMesh() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      <motion.div
        className="absolute -left-32 top-[-10%] h-[34rem] w-[34rem] rounded-full"
        style={{ background: "radial-gradient(circle, rgba(16,185,129,0.16), transparent 65%)", filter: "blur(60px)" }}
        animate={{ x: [0, 60, 0], y: [0, 40, 0] }}
        transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute right-[-15%] top-[20%] h-[30rem] w-[30rem] rounded-full"
        style={{ background: "radial-gradient(circle, rgba(212,175,55,0.14), transparent 65%)", filter: "blur(70px)" }}
        animate={{ x: [0, -50, 0], y: [0, 60, 0] }}
        transition={{ duration: 22, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute bottom-[-20%] left-[30%] h-[26rem] w-[26rem] rounded-full"
        style={{ background: "radial-gradient(circle, rgba(224,122,95,0.10), transparent 65%)", filter: "blur(80px)" }}
        animate={{ x: [0, 40, 0], y: [0, -30, 0] }}
        transition={{ duration: 26, repeat: Infinity, ease: "easeInOut" }}
      />
    </div>
  );
}
